import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { IItemForGetShortInfo } from 'types';
import MultipleSelect from './components/MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './ModifierGroupsAsAdditionalMultipleSelect.module.scss';

interface IModifierGroupsAsAdditionalMultipleSelect {
	setModifierGroupsAsAdditional: (value: string[]) => void;
	fetchedModifierGroups: IItemForGetShortInfo[];
	selectedModifierGroups: string[];
	initialModifierGroupsAsAdditional: string[];
	selectedModifierGroupsAsAdditional: string[];
}

const ModifierGroupsAsAdditionalMultipleSelect: React.FC<IModifierGroupsAsAdditionalMultipleSelect> = ({
	setModifierGroupsAsAdditional,
	fetchedModifierGroups,
	selectedModifierGroups,
	initialModifierGroupsAsAdditional,
	selectedModifierGroupsAsAdditional,
}) => {
	const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

	const modifierGroupsAsAdditional = useMemo(
		() => fetchedModifierGroups.filter((el) => selectedModifierGroups.includes(el.id)),
		[fetchedModifierGroups, selectedModifierGroups],
	);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = selectedModifierGroupsAsAdditional.filter((el) => el !== id);
			setModifierGroupsAsAdditional(updatedSelectedItems);
		},
		[setModifierGroupsAsAdditional, selectedModifierGroupsAsAdditional],
	);

	const dishesList = useMemo(() => {
		return selectedModifierGroupsAsAdditional.map((el) => {
			const label = fetchedModifierGroups.find((item) => item.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [handleRemove, fetchedModifierGroups, selectedModifierGroupsAsAdditional]);

	useEffect(() => {
		if (isFirstRender && selectedModifierGroups.length) {
			setModifierGroupsAsAdditional(initialModifierGroupsAsAdditional);
			setIsFirstRender(false);
		}
	}, [isFirstRender, selectedModifierGroups, initialModifierGroupsAsAdditional]);

	return (
		<div className={style.container}>
			<MultipleSelect
				data={modifierGroupsAsAdditional}
				setModifierGroupsAsAdditional={setModifierGroupsAsAdditional}
				selectedModifierGroups={selectedModifierGroups}
				selectedModifierGroupsAsAdditional={selectedModifierGroupsAsAdditional}
			/>
			<div className={style.groupsList}>{dishesList}</div>
		</div>
	);
};

export default React.memo(ModifierGroupsAsAdditionalMultipleSelect);
